function InfoSliderLoadingIndicator(): JSX.Element {
  return (
    <div>
      <div className="flex justify-between items-center border-b p-6">
        <div className="flex justify-between items-center">
          <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        </div>

        <div className="flex justify-between items-center">
          <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        </div>
      </div>
      <div className=" justify-between items-center p-6">
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
      </div>
      <div className=" justify-between items-center p-6">
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
      </div>
      <div className=" justify-between items-center p-6">
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
      </div>
      <div className=" justify-between items-center p-6">
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
      </div>
      <div className=" justify-between items-center p-6">
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
      </div>
      <div className=" justify-between items-center p-6">
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-[85px] animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
        <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 my-3 w-full animate-pulse" />
      </div>
    </div>
  );
}

export default InfoSliderLoadingIndicator;
